<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">E-Coupons</h3>
        </div>
        <div class="col-auto float-right ml-auto">
          <button
            class="btn add-btn"
            @click="
              $router.push({
                name:
                  role == 'super_admin' || role == 'admin'
                    ? 'adminEcouponAdd'
                    : 'merchantEcouponAdd',
              })
            "
          >
            <i class="fa fa-plus"></i>Add E-Coupon
          </button>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Search Filter -->
    <div class="row">
      <div class="col-md-3" v-if="role == 'admin'">
        <div class="form-group">
          <label>Merchant</label>
          <select class="form-control" v-model="merchant">
            <option value>All</option>
            <option value="Burger King">Burger King</option>
            <option value="KFC">KFC</option>
            <option value="McDonald's">McDonald's</option>
            <option value="Pizza Hut">Pizza Hut</option>
          </select>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>Code</label>
          <input
            type="text"
            placeholder=""
            class="form-control"
            maxlength="20"
            v-model="code"
          />
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>Start Date</label>
          <input type="date" class="form-control" v-model="startDate" />
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>Expiry Date</label>
          <input type="date" class="form-control" v-model="expiryDate" />
        </div>
      </div>
      <div class="col-md-3 fit-content">
        <div class="form-group">
          <label>Discount Type</label>
          <select class="form-control" v-model="discountType">
            <option value>All</option>
            <option value="Percentage Discount">Percentage Discount</option>
            <option value="Amount Discount">Amount Discount</option>
          </select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2">
        <div class="form-group">
          <label>Distribution Channel</label>
          <select class="form-control" v-model="distributionChannel">
            <option value>All</option>
            <option value="Email">Email</option>
            <option value="Portal">Portal</option>
            <option value="API">API</option>
          </select>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>Status</label>
          <select class="form-control" v-model="status">
            <option value>All</option>
            <option value="Draft">Draft</option>
            <option value="Active">Active</option>
            <option value="Expired">Expired</option>
          </select>
        </div>
      </div>
      <div class="col-md-1">
        <button class="btn btn-primary filter-btn" @click="search">
          Search
        </button>
      </div>
    </div>
    <!-- /Search Filter -->

    <!-- Pagination -->
    <div class="row mt-3">
      <div class="col-md-6">
        Show
        <select
          class="custom-select custom-select-sm"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Table List -->
    <div class="row mt-2">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th v-if="role == 'admin'">Merchant</th>
                <th>Code</th>
                <th>Start Date</th>
                <th>Expiry Date</th>
                <th>Discount Type</th>
                <th>Discount Amount</th>
                <th>Distribution Channel</th>
                <th>Status</th>
                <th class="action-col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(ecoupon, i) in ecoupons" :key="i">
                <td v-if="role == 'admin'">{{ ecoupon.merchant }}</td>
                <td>{{ ecoupon.code }}</td>
                <td>{{ ecoupon.startDate }}</td>
                <td>{{ ecoupon.expiryDate }}</td>
                <td>{{ ecoupon.discountType }}</td>
                <td>{{ ecoupon.discountAmount }}</td>
                <td>{{ ecoupon.distributionChannel }}</td>
                <td>{{ ecoupon.status }}</td>
                <td class="action-col">
                  <button class="btn btn-sm btn-primary">
                    <i class="fa fa-pencil mr-1"></i>Edit
                  </button>
                  <button class="btn btn-sm btn-danger">
                    <i class="fa fa-trash-o mr-1"></i>Delete
                  </button>
                </td>
              </tr>
              <tr v-if="ecoupons && !ecoupons.length">
                <td colspan="9" class="text-center">
                  {{ noRecordText }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->

    <!--Pagination -->
    <div class="row mb-4" v-if="ecoupons && ecoupons.length">
      <div
        class="col-md-6 col-lg-6 col-sm-6 my-auto text-center text-lg-left text-md-left"
      >
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          ecoupons.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-sm btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-sm btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />
          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-sm btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-sm btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->
  </div>
</template>

<script>
import config from "../../config.js";
export default {
  data() {
    return {
      noRecordText: config.NO_RECORD_TEXT,
      ecoupons: [],
      //pagination
      paging: {
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 20,
        Sizes: [20, 50, 100],
        SortBy: "",
      },
      totalRecords: "",
      //filter
      merchant: "",
      code: "",
      startDate: "",
      expiryDate: "",
      discountType: "",
      distributionChannel: "",
      status: "",
    };
  },
  computed: {
    role() {
      let data = JSON.parse(localStorage.getItem("emstoken"));
      return data.role;
    },
  },
  watch: {
    "paging.SizePerPage": function () {
      this.paging.CurrentPage = 1;
      this.getUserList();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },
  methods: {
    search() {},
    getEcouponList() {
      this.ecoupons = [
        {
          merchant: "Burger King",
          code: "BK-001",
          startDate: "1 January 2025",
          expiryDate: "31 December 2025",
          discountType: "Percentage Discount",
          discountAmount: "30%",
          distributionChannel: "Email",
          status: "Active",
        },
        {
          merchant: "KFC",
          code: "KFC-XA9D1",
          startDate: "1 January 2025",
          expiryDate: "31 January 2025",
          discountType: "Amount Discount",
          discountAmount: "$20",
          distributionChannel: "Portal",
          status: "Active",
        },
        {
          merchant: "McDonald's",
          code: "MCD-1242",
          startDate: "1 April 2024",
          expiryDate: "2 April 2024",
          discountType: "Amount Discount",
          discountAmount: "$25",
          distributionChannel: "API",
          status: "Expired",
        },
        {
          merchant: "Pizza Hut",
          code: "PHT-1242",
          startDate: "1 May 2025",
          expiryDate: "2 May 2025",
          discountType: "Percentage Discount",
          discountAmount: "25%",
          distributionChannel: "Email",
          status: "Draft",
        },
      ];
      this.totalRecords = this.ecoupons.length;
      this.paging.TotalPage = 1;
      if (this.paging.CurrentPage > this.paging.TotalPage) {
        this.paging.CurrentPage = 1;
      }
    },
    //for pagination
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getEcouponList();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getEcouponList();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getEcouponList();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getEcouponList();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getEcouponList();
    },
  },
  created() {
    this.getEcouponList();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Share/EcouponList.vue